// app/customs/binaryviewer/index.tsx

'use client';
import * as Global from "@utils/global";
import "./index.css";

interface VideoPlayerProps {
  src: string;
  title?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src, title }) => {
  return (
    <div className="video-player">
      {/* {title && <div className="video-title">{title}</div>} */}
      <video
        src={src}
        controls
        autoPlay
        style={{ maxWidth: "100%", maxHeight: "80vh" }}
      />
    </div>
  );
};

export default VideoPlayer;